// sort-imports-ignore
import { CalendarIcon } from "../../Icons";
import { useState } from "react";
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import { twMerge } from "tailwind-merge";
import "react-datepicker/dist/react-datepicker.css";
import { DEFAULT_DATE_PICKER_MAX_DATE, DEFAULT_DATE_PICKER_MIN_DATE } from "./datepicker.constants";
import "./datepicker.css";

interface Props extends Omit<ReactDatePickerProps, "value" | "selected"> {
  selected: Date | null;
  isDisabled?: boolean;
  onChange: (date: Date) => void;
  error?: string;
}

const Datepicker: React.FC<Props> = ({ dateFormat = "MM/dd/yyyy", isDisabled, onChange, error, ...restProps }) => {
  const [isOpen, setIsOpen] = useState(false);
  const iconColor = isOpen ? "#1F8475" : "#888888";

  return (
    <ReactDatePicker
      onChange={onChange}
      placeholderText={restProps.placeholderText || "Select a date"}
      dropdownMode="select"
      className={twMerge("datepicker", error && "datepicker-error", "focus:outline-none")}
      calendarIconClassname="datepicker-icon"
      icon={<CalendarIcon style={{ color: iconColor }} />}
      showIcon
      showMonthDropdown
      showYearDropdown
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
      minDate={DEFAULT_DATE_PICKER_MIN_DATE}
      maxDate={DEFAULT_DATE_PICKER_MAX_DATE}
      calendarStartDay={1}
      disabled={isDisabled}
      {...restProps}
    />
  );
};

export default Datepicker;
